document.addEventListener('DOMContentLoaded', function() {
    const countdownTimer = document.getElementById('countdown-timer');
    const timerElement = countdownTimer.querySelector('#timer');
    const initialTime = 69; // starting time in seconds
    let timeLeft = initialTime;

    // Check if a time is stored in localStorage
    if (localStorage.getItem('timeLeft')) {
        timeLeft = parseInt(localStorage.getItem('timeLeft'), 10);
    }

    function updateTimer() {
        if (timeLeft <= 0) {
            clearInterval(timerInterval);
            localStorage.removeItem('timeLeft'); // Remove stored time once countdown finishes
            countdownTimer.innerHTML = `
                <div class="final-message" style="background-image: url('https://example.com/your-background.jpg');">
                    Your Time Is Up!
                </div>`;
            setTimeout(() => {
                window.location.href = 'https://www.antisocialsocialclub.com/cart'; // Replace with your desired URL
            }, 2000);
            return;
        }

        if (timeLeft <= 10) {
            timerElement.classList.toggle('blink');
        }

        timerElement.textContent = timeLeft;
        localStorage.setItem('timeLeft', timeLeft); // Store the remaining time in localStorage
        timeLeft--;
    }

    const timerInterval = setInterval(updateTimer, 1000);

    // Clear the timer when the user navigates away
    window.addEventListener('pagehide', function () {
        clearInterval(timerInterval);
    });
});
